<div class="m-enseignes">
  <div class="m-enseignes__header">
    <app-ui-section-header
      [title]="'ENSEIGNES.TITLE' | translate"
      [description]="'ENSEIGNES.SUBTITLE' | translate"
    />
    <button class="m-enseignes__add" (click)="onAddEnseigne()">
      {{ 'ENSEIGNES.ADD_NEW' | translate }}
    </button>
  </div>

  @if (isLoading()) {
    <div class="m-enseignes__loading">{{ 'COMMON.LOADING' | translate }}</div>
  }
  @if (error()) {
    <div class="m-enseignes__error">{{ 'COMMON.ERROR' | translate }}: {{ error() }}</div>
  }

  <div class="m-enseignes__grid">
    @for (config of enseignes(); track config.enseigne) {
      <app-enseigne-card
        [enseigne]="config"
        (edit)="onEditEnseigne(config)"
        (delete)="onDeleteEnseigne($event)"
      />
    }
  </div>

  @if (showModal()) {
    <app-enseigne-form-modal
      [enseigne]="selectedEnseigne()"
      [availableCountryCodes]="availableCountryCodes()"
      (enseigneSubmit)="onModalSubmit($event)"
      (enseigneCancel)="onModalCancel()"
    />
  }

  <app-delete-confirmation-modal
    [isOpen]="showDeleteModal()"
    [title]="'COMMON.DELETE_MODAL.TITLE' | translate"
    [message]="'COMMON.DELETE_MODAL.MESSAGE' | translate"
    [itemName]="enseigneToDelete()?.enseigne"
    [confirmLabel]="'COMMON.DELETE_MODAL.CONFIRM' | translate"
    [cancelLabel]="'COMMON.DELETE_MODAL.CANCEL' | translate"
    [deletingLabel]="'COMMON.DELETE_MODAL.DELETING' | translate"
    [isDeleting]="isLoading()"
    (confirmed)="onConfirmDelete()"
    (cancelled)="onCancelDelete()"
  />
</div>
